import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { Select, Button, Divider, Layout, Row, Col } from 'antd';
import { Spinner } from 'reactstrap';
import axios from '../../utils/request';
const { Content } = Layout;
const { Option } = Select;

export class SfcExam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isReady: false,
      tenantId: "",
      userId: "",
      personIds: "",
      applyIds: "",
      jobId: "",
      commonParamater: "",
      children: [],
      loadings: [],
      examInfoList: [],
      errorMessage: "",
      resultMessage: ""
    }
  };


  handleChange = (value, options) => {
    let examInfos = options.map(item => {
      return { ExamEid: item.key, ExamName: item.value }
    })
    this.setState({ examInfoList: examInfos });
    console.log(`selected ${examInfos}`);
  };

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    this.state.commonParamater = urlParams.get("commonParamater");
    this.state.tenantId = urlParams.get("tenantId");
    this.loadExamList(this.state.tenantId,
      this.state.commonParamater);
  };

  examLauach = index => {
    const params = {
    
      personIds: this.state.personIds,
      jobId: this.state.jobId,
      applyIds: this.state.applyIds,
      examInfos: this.state.examInfoList
    };

    if(params.examInfos.length<=0)
    {
      this.setState({ isReady: true });
      this.setState({ errorMessage: "请选择试卷" });
      return;
    }

    const bodyString = JSON.stringify(params);
    axios.post("/api/SfcExamination/LaunchExam",
      bodyString,
      {
        headers: { "Content-Type": "application/json" }
      })
      .then(res => {
        const isSuccessValue = res.data.code == "200";
        console.log("打印发起试卷结果",res);
        if (!isSuccessValue) {
          this.setState({ errorMessage: res.data.message });
        } else {
          this.setState({ resultMessage: res.data.data });
        }

        this.setState({ isReady: true });
      })
      .catch(reason => {
        this.setState({ errorMessage: "操作异常，请联系管理员！" });
      })
      .finally(
      );


    this.setState(({ loadings }) => {
      const newLoadings = [...loadings];
      newLoadings[index] = true;
      return {
        loadings: newLoadings,
      };
    });


    setTimeout(() => {
      this.setState(({ loadings }) => {
        const newLoadings = [...loadings];
        newLoadings[index] = false;
        return {
          loadings: newLoadings,
        };
      });
    }, 6000);
  };

  loadExamList(tenantId, commonParamater) {
    const params = {
      tenantId,
      commonParamater
    }

    axios.get("/api/SfcExamination/GetSfcExamination", { params: params })
      .then(res => {
        let errorMessage = "";
        console.log("打印试卷列表",res);
        if (res.status == 200 && res.data.code == "200") {
          if (res.data.data !== "") {
            let a = res.data.data.sfcExams.map(item => {
              return <Option value={item.title} key={item.eid}>{item.title}</Option>
            })
            this.setState({
              children: a
            });
            this.setState({ personIds: res.data.data.personIds });
            this.setState({ userId: res.data.data.userId });
            this.setState({ jobId: res.data.data.jobId });
            this.setState({ applyIds: res.data.data.applyIds });
          }
          else {
            this.setState({ errorMessage: res.data.message });
          }
          this.setState({ isReady: true });
        }
        else {
          this.setState({ errorMessage: res.data.message });
        }
        this.setState({ isReady: true });
      })
      .catch(reason => {
        console.log(reason);
        this.setState({ errorMessage: "操作异常，请联系管理员！" });
      })
      .finally(
      );
  }


  render() {
    const { loadings } = this.state;
    if (this.state.isReady) {
      if (this.state.errorMessage !== "") {
        return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
      }
      else {
        return (
          <>
            <Content>
              <Divider style={{ padding: "6px 10px" }} orientation="left">请选择要发起考试的试卷:</Divider>
              <Row>
                <Col span={24} style={{ textAlign: "center", padding: "10px 10px 2px 10px" }}>
                  <Select id="exams" mode="multiple" style={{ width: '100%' }} placeholder="请选择试卷" onChange={this.handleChange}>
                    {this.state.children}
                  </Select>
                </Col>
              </Row>

              <Row>
                <Col span={24} style={{ padding: "2px 10px" }}>
                  <Button id="btnCommit" type="primary" style={{ float: "right" }} loading={loadings[0]} onClick={() => this.examLauach(0)}>
                    发起考试
                  </Button>
                </Col>
              </Row>

              <Row style={{ textAlign: "left", padding: "10px" }}>
                <Col span={24}>
                  <div>{this.state.resultMessage}</div>
                </Col>
              </Row>
            </Content>
          </>
        )
      }
    }
    else {
      return (
        <div style={{ textAlign: "center", lineHeight: "100vh" }}>
          <Spinner type="grow" color="primary" />
          <Spinner type="grow" color="secondary" />
          <Spinner type="grow" color="success" />
          <Spinner type="grow" color="danger" />
          <Spinner type="grow" color="warning" />
          <Spinner type="grow" color="info" />
          <Spinner type="grow" color="dark" />
        </div>
      );
    }
  };
}